import { LoginComponent } from "../app/components/login/login.component";

export const environment = {
    production: false,
    language: "sl",
    //wgProfileHost: "http://localhost:5005",
    //wgPlatformHost: "http://localhost:4300",
    wgProfileHost: "https://razpisi-test-api.olympic.si",
    wgPlatformHost: "https://razpisi-test-platform.olympic.si",

    loginComponent: LoginComponent,
    projIcon: "/assets/project-custom/images/logo.png",
    sidebarIcon: "/assets/project-custom/images/logo.png",
    projectCode: "BORZEN_OVE4",
    projectName: "",
    locale: 'sl-SI',
    useRouteAndMasterpageCache: true,
    ADLoginEnabled: false,
    dateFormat: 'DD.MM.YYYY',
    navigateAwayPopupEnabled: true,
    useEtag: true,
    newRegistrationLinkDocument: "",
    maxChunkNumber: 200,
    maxFileSizeInMb: 100,
    maxRecordNumberPerPageListing: 30,
    cacheEnabled: false,
    version: '1.1.0',
    showOnlyUserInHeader: true,
    googleClientId: "344277045222-cilssva2bmssa4jel0ni23q2ip880q5f.apps.googleusercontent.com",
    useOldSearchViewFeature:false,
    useInlineSearch:false,
    usernameAlwaysToLower:false,
    theme: '',
    maxFileSizeInMbInMessenger: 5,
    projectSidebarName: ''
};
